import { Fourier } from "../../../../content/pages/projects/fourier/fourier.tsx";
import * as React from 'react';
export default {
  Fourier,
  React
};